<template>
  <div class="d-flex justify-content-center" id="icons-container">
    <b-card 
      class="icon-card text-center cursor-pointer mb-0 mr-2" 
      :class="{'bg-primary text-white': selectedType == 0}" 
      @click="$emit('change-type', 0)"
      v-if="isDeveloper || $store.state.user.userData.permissions.includes('paylasimlar.fenomen_paylasimi_yapabilir_duzenleyebilir')"
    >
      <feather-icon
        class="cursor-pointer"
        icon="WindIcon"
        size="25"
      />
      <div class="mt-2 mb-0">
        Sosyal Medya
      </div>
    </b-card>

    <b-card 
      class="icon-card text-center cursor-pointer mb-0 mr-2" 
      :class="{'bg-primary text-white': selectedType == 1}" 
      @click="$emit('change-type', 1)"
      v-if="isDeveloper || $store.state.user.userData.permissions.includes('firma_paylasimi.story_ekleyebilir_duzenleyebilir')"
    >
      <feather-icon
        class="cursor-pointer"
        icon="InstagramIcon"
        size="25"
      />
      <div class="mt-2 mb-0">
        Story Link<br/>Ekle
      </div>
    </b-card>

    <b-card 
      class="icon-card text-center cursor-pointer mb-0 mr-2" 
      :class="{'bg-primary text-white': selectedType == 2}" 
      @click="$emit('change-type', 2)"
      v-if="isDeveloper || $store.state.user.userData.permissions.includes('firma_paylasimi.sms_ekleyebilir_duzenleyebilir')"
    >
      <feather-icon
        class="cursor-pointer"
        icon="MessageSquareIcon"
        size="25"
      />
      <div class="mt-2 mb-0">
        SMS<br/>Ekle
      </div>
    </b-card>
    <b-card 
      class="icon-card text-center cursor-pointer mb-0" 
      :class="{'bg-primary text-white': selectedType == 4}" 
      @click="$emit('change-type', 4)"
      v-if="isDeveloper || $store.state.user.userData.permissions.includes('firma_paylasimi.whatsapp_ekleyebilir_duzenleyebilir')"
    >
      <feather-icon
        class="cursor-pointer"
        icon="MessageCircleIcon"
        size="25"
      />
      <div class="mt-2 mb-0">
        Whatsapp<br/>Ekle
      </div>
    </b-card>
  </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'

export default {
  name: 'TypeSelection',
  components: {
    BCard
  },
  props: {
    selectedType: {
      type: Number,
      default: null
    }
  },
  emits: ['change-type']
}
</script>

<style lang="scss" scoped>
#icons-container .icon-card {
  width: 150px;
  &:hover {
    background-color: #7367f0;
    color: white;
  }
}
</style>